import React from 'react';
import PinpointCarousel from './components/PinpointCarousel';
import Background from './pages/components/background';
import LogoNlogin from './pages/components/logoNlogin';
import {movieList} from './jsonData'

const App = () => {
  // const [movieList, setMovieList] = useState();
  // useEffect(() => {
  //   fetch('http://localhost:3000/posterList.json')
  //   .then(res => res.json())
  //   .then(json => setMovieList(json));
  // }, [])
  let prevPage = 0;
  const handleScroll = () => {
    const windowCall = window;
    let currentPage = Math.floor(window.scrollY / window.innerHeight);
    if (prevPage !== currentPage) {
      document.getElementById(`pin${prevPage}`).classList.remove("pinpointOpacity");
      prevPage = currentPage;
      document.getElementById(`pin${currentPage}`).classList.add("pinpointOpacity");
    }

  // currentPage = Math.floor(windowCall.scrollY / windowCall.innerHeight);
  const numberOfPages = windowCall.pageYOffset / windowCall.innerHeight;
  let rest = windowCall.scrollY % windowCall.innerHeight;
  let movingUpLine = Math.floor(windowCall.innerHeight * 0.1);
  let newTop = windowCall.scrollY;
  // console.log(windowCall.scrollY % windowCall.innerHeight)
  if (rest < movingUpLine)
    newTop = windowCall.innerHeight * Math.floor(windowCall.scrollY / windowCall.innerHeight);
  else
    newTop = windowCall.scrollY - rest + windowCall.innerHeight;
    
    // windowCall.scrollTo({
      //   top: newTop,
      //   behavior: 'smooth'
      // })
      // let newTop = windowCall.innerHeight * (windowCall.scrollY / windowCall.innerHeight);
      
      // if (windowCall.scrollY % windowCall.innerHeight != 0)
      //   newTop = windowCall.innerHeight * (windowCall.scrollY / windowCall.innerHeight);
      // console.log(Math.floor(newTop));
      // windowCall.scrollTo({
        //   top: Math.floor(newTop),
        //   behavior: 'smooth'
        // })
        
      }


  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  },[])

  
  return (
    <div className="homeWrapper">
    <LogoNlogin logo={movieList ? movieList.logo : ""} />
    <PinpointCarousel extraCSS={"pinpointPosition"} movie_img={movieList ? movieList.movie_img : ""} />
    <Background movieList={movieList ? movieList : ""} />
    </div>
  )
}

export default App;
